@if(!!card){
<div class="card flex flex-col justify-center gap-6 content-normal md:flex-row md:max-w-full mx-auto rounded-lg md:rounded-l-lg overflow-hidden mt-[30px]">
  @for (lifestyle of selected_lifestyles.slice(0,showLimit); track $index) {
  <lifestylecard id="lifestyle-{{ $index}}" index="{{$index}}" [lifestyle]="lifestyle" [(selectedLifestyle)]="selectedLifestyle"></lifestylecard>
  }
</div>
}